import type { LifeProportions } from "./life-proportions";

export function lifeBarHtml(proportions: LifeProportions): string {
  const total = proportions.livedYears + proportions.remainingYears;
  if (total <= 0) return "";

  const livedFraction = proportions.livedYears / total;
  const remainingFraction = proportions.remainingYears / total;
  const livedYears = Math.round(proportions.livedYears);
  const remainingYears = Math.round(proportions.remainingYears);

  const segments: string[] = [];
  if (livedFraction > 0) {
    segments.push(
      `<div class="life-bar-segment life-bar-lived" data-testid="life-bar-lived" data-fraction="${livedFraction}" style="width: ${(livedFraction * 100).toFixed(4)}%;"><span class="life-bar-segment-label">${livedYears} lived</span></div>`,
    );
  }
  if (remainingFraction > 0) {
    segments.push(
      `<div class="life-bar-segment life-bar-remaining" data-testid="life-bar-remaining" data-fraction="${remainingFraction}" style="width: ${(remainingFraction * 100).toFixed(4)}%;"><span class="life-bar-segment-label">${remainingYears} left</span></div>`,
    );
  }

  return `<div class="life-bar" data-testid="life-bar" role="img" aria-label="Life bar chart">${segments.join("")}</div>`;
}
